<template>
    <div class="fullscreen-menu">
      <div class="menu-container">
        <img v-for="(image, index) in menuImages" :key="index" :src="image" :alt="`Menu Page ${index + 1}`" class="menu-image" />
      </div>
      <button class="back-button" @click="closeFullScreen">返回</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FullScreenMenu',
    data() {
      return {
        menuImages: [],
      };
    },
    mounted() {
      this.loadMenuImages();
    },
    methods: {
      loadMenuImages() {
        for (let i = 0; i <= 35; i++) {
          const imageName = `menu_${i.toString().padStart(2, '0')}.jpg`;
          const imagePath = `/assets/${imageName}`;
          this.menuImages.push(imagePath);
        }
      },
    //   loadMenuImages() {
    //   // 修改图片路径 或 使用require来引入, 参考上一个回答
    //   for (let i = 0; i <= 35; i++) {
    //     const imageName = `menu_${i.toString().padStart(2, '0')}.jpg`;
    //     const imagePath = `/${imageName}`; // 或者 const imagePath = require(`@/assets/${imageName}`);
    //     this.menuImages.push(imagePath);
    //   }，
      closeFullScreen() {
        // this.$emit('close'); // 触发一个 'close' 事件，通知父组件关闭全屏菜单
        // this.$router.back();  // 使用 $router.back() 返回上一页
         this.$router.push('/');
      },
    },
  };
  </script>
  
  <style scoped>
  .fullscreen-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9); /* 半透明黑色背景 */
    z-index: 1000; /* 确保在最上层 */
    overflow-y: auto; /* 允许滚动 */
  }
  
  .menu-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    padding: 20px; /* 添加内边距 */
  }
  
  .menu-image {
    width: 100%;
    max-width: 500px; /* 适当增大最大宽度 */
    height: auto;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  }
  
  .back-button {
    position: fixed;
    top: 20px;
    left: 20px;
    padding: 10px 20px;
    background-color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    z-index: 1001; /* 确保在图片之上 */
  }
  
  /* 针对大屏幕的优化 */
  @media (min-width: 768px) {
    .menu-image {
      max-width: 700px;
    }
  }
  
  @media (min-width: 1024px) {
    .menu-image {
      max-width: 900px;
    }
  }
  </style>